import { initSolrCategoryCardInfo } from "./elements/_categoryCardInfo.js";
import {initSolrCategorySearch} from './elements/_categorySolrSearch.js';
import { initTopbarHideOnScroll } from "./elements/_topbarHideOnScroll.js";

/**
 * Initialize the custom scripts for the Stadt Fürth website
 */
function initFuerthCustomJS() {
    initSolrCategoryCardInfo();
    initSolrCategorySearch();
    initTopbarHideOnScroll()
}

/**
 * Wait for the page to load before running the custom scripts
 */
if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(initFuerthCustomJS);
} else {
    document.addEventListener("DOMContentLoaded", initFuerthCustomJS);
}
